/*
 * rheincool — Markenvergleich-Tabelle (Markenvergleich-Handoff §BrandCompareTable)
 * Abonniert rcStore 'matcher' ({zweck, handle}) und hebt die Spalten hervor,
 * deren data-passend-Liste den gewählten Zweck enthält: .is-highlighted
 * (hellblauer Zellhintergrund) + sichtbares Badge „passend für: {Zweck}"
 * im Spaltenkopf — nie nur Farbe (A11y). Keine Gewinner-Markierung.
 */
(() => {
  'use strict';
  if (customElements.get('rc-brand-compare')) return;

  class RcBrandCompare extends HTMLElement {
    connectedCallback() {
      this.zweckLabels = {};
      const configEl = this.querySelector('[data-brand-config]');
      if (configEl) {
        try {
          this.zweckLabels = JSON.parse(configEl.textContent).zweckLabels || {};
        } catch (error) {
          console.warn('[rc-brand-compare] config', error);
        }
      }
      if (window.rcStore) {
        window.rcStore.subscribe('matcher', (value) => this.applyMatch(value));
      }
    }

    applyMatch(value) {
      const zweck = value && value.zweck ? String(value.zweck).trim() : '';

      this.querySelectorAll('[data-brand-col].is-highlighted').forEach((cell) => {
        cell.classList.remove('is-highlighted');
      });
      this.querySelectorAll('[data-match-badge]').forEach((badge) => {
        badge.hidden = true;
      });
      if (!zweck) return;

      this.querySelectorAll('th[data-brand-col]').forEach((th) => {
        const passend = (th.getAttribute('data-passend') || '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);
        if (!passend.includes(zweck)) return;

        const col = th.getAttribute('data-brand-col');
        this.querySelectorAll(`[data-brand-col="${col}"]`).forEach((cell) => {
          cell.classList.add('is-highlighted');
        });
        const badge = th.querySelector('[data-match-badge]');
        if (badge) {
          const label = badge.querySelector('[data-match-zweck]');
          if (label) label.textContent = this.zweckLabels[zweck] || zweck;
          badge.hidden = false;
        }
      });
    }
  }

  customElements.define('rc-brand-compare', RcBrandCompare);
})();
